import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventDeviceFields from './EventDeviceFields'

export const EventDeviceEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <EventDeviceFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default EventDeviceEdit
